module.exports = __webpack_public_path__ + "img/Muzemix_Banner_LoggedIn.1e40797e.png";